export const baseUrl = process.env.REACT_APP_BASE_URL;
export const appVersion = process.env.REACT_APP_VERSION;
export const baseUrlSocket = process.env.REACT_APP_BASE_URL_SOCKET;
//Auth
export const authRegisterUrl: string = `${baseUrl}/auth/register`;
export const sessionUrl: string = `${baseUrl}/auth/sessions`;
export const authCheck: string = `${baseUrl}/auth/check`;
export const sessionDeleteUrl: string = `${baseUrl}/auth/logout`;
export const authForgetPasswordUrl: string = `${baseUrl}/auth/password/forget`;
export const authResetPasswordUrl: string = `${baseUrl}/auth/password/reset`;
export const authVerifyPasswordUrl: string = `${baseUrl}/auth/password/verify`;
export const authLoginUrl: string = `${baseUrl}/auth/login`;
//App
export const indexUserTrackersUrl: string = `${baseUrl}/clients/tracers`;
export const indexAllServicesUrl: string = `${baseUrl}/clients/tracers/services`;
export const getProfileInfoUrl: string = `${baseUrl}/profile`;
export const updateProfileInfoUrl: string = `${baseUrl}/profile`;
export const indexTransactionsUrl: string = `https://beta.e-wigo.co/payment/api/user-invoices`;
export const requestLocationReportUrl: string = `${baseUrl}/clients/reports/location/request`;
export const checkLocationReportUrl: string = `${baseUrl}/clients/reports/location/check`;
export const trackerNotificationsUrl: string = `${baseUrl}/clients/notifications`;
export const getAllGeoAreaUrl: string = `${baseUrl}/clients/tracers/geo-areas`;
export const getGeoAreaUrl: string = `${baseUrl}/clients/tracers`;
export const createGeoAreaUrl: string = `${baseUrl}/clients/tracers`;
export const deleteGeoAreaUrl: string = `${baseUrl}/clients/tracers`;
export const updateGeoAreaUrl: string = `${baseUrl}/clients/tracers`;
